export default __webpack_public_path__ + "static/media/add_layer.6175971d.png";